<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--team-add-user">
    <!-- メインコンテンツエリア -->
    <main class="l-main">
      <breadcrumb :breadcrumb-data="breadcrumbData" />

      <!-- メインコンテンツ: 上段共通エリア -->
      <div class="l-main-head">
        <div class="c-title">
          <div class="c-title__text c-title__text--blue u-fs34">チームユーザーの新規追加</div>
          <div class="c-text">追加するチームメンバーのメールアドレス（ログインID）と名前・権限・アクセスできるプロジェクトを設定してください。</div>
        </div>
      </div>
      <!-- /メインコンテンツ: 上段共通エリア -->

      <!-- ユーザー情報入力エリア -->
      <div class="l-main-content">
        <add-user-form :team-url="teamUrl" :services="services" />
      </div>
      <!-- /ユーザー情報入力エリア -->

    </main>
    <!-- /メインコンテンツエリア -->
  </div>
  <!-- /ページ内容 -->
</template>

<script>
export default {
  props: {
    breadcrumbData: Array,
    services: Array,
    teamUrl: String,
  },
  mounted: function() {
    import('../../funcs/pages/team-add-user').then(module => {
      module.TeamAddUser();
    });
  },

}
</script>
